import React from 'react';
import { Box, Typography, Button, Modal, IconButton, Divider, CircularProgress } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useConfirmModal } from './styles';
import { useTranslation } from 'react-i18next';

interface ConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => Promise<void>;
  title: string;
  description: string;
  reload?: () => void;
}

export const ConfirmModal: React.FC<ConfirmModalProps> = ({
  open,
  onClose,
  onConfirm,
  title,
  description,
  reload
}) => {
  const styles = useConfirmModal();
  const { t } = useTranslation()
  const [isDeleting, setIsDeleting] = React.useState(false);

  const handleConfirm = async () => {
    setIsDeleting(true);
    try {
      window.onbeforeunload = null;
      await onConfirm();
      onClose();
      if (reload) {
        reload();
      } else {
        window.location.reload();
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsDeleting(false);
    }
  };

  return (
    <Modal
      open={open}
      onClose={(event, reason) => {
        if (reason === 'escapeKeyDown') {
          onClose();
        }
      }}
      disableEscapeKeyDown={false}
    >
      <Box sx={styles.container}>
        <IconButton
          aria-label="close"
          onClick={onClose}
          disabled={isDeleting}
          sx={styles.closeIcon}
        >
          <CloseIcon />
        </IconButton>

        <Box sx={{ padding: 3 }}>
          <Typography variant="h6" component="h2" fontWeight={600} sx={{ mb: 4 }}>
            {title}
          </Typography>
          <Typography sx={styles.description}>{description}</Typography>
        </Box>

        <Divider sx={{ mt: 3, mb: 0, width: '100%' }} />

        <Box sx={styles.btnContainer}>
          <Button
            onClick={onClose}
            disabled={isDeleting}
            sx={styles.cancelBtn}
          >
            {t('reportFolio.detail.general.cancel')}
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isDeleting}
            sx={styles.confirmBtn}
          >
            {isDeleting ? (
              <CircularProgress size={24} color="inherit" />
            ) : (
              t('reportFolio.detail.general.confirm')
            )}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};